import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VariantService } from 'src/app/admin-pages/variant.service';
import { BackOfficeService } from 'src/app/back-office-pages/back-office.service';
import { ApiService } from 'src/app/services/api.service';
import { ConfigService } from 'src/app/services/config.service';
import { PrivilegesService } from 'src/app/services/privileges.service';
import { UtilityService } from 'src/app/services/utility.service';
import { menuItems } from 'src/app/third-party/service-near/menu';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { Subscription } from 'rxjs';
import { SubscriptionsService } from 'src/app/services/subscriptions.service';

@Component({
  selector: 'app-servicenear-side-menu',
  templateUrl: './servicenear-side-menu.component.html',
  styleUrls: ['./servicenear-side-menu.component.scss']
})
export class ServicenearSideMenuComponent implements OnInit, OnDestroy{
  isSearchActive: boolean = false;
  isFilterActive: boolean = false;
  selectedShop: any = { key: 0, a: 'dssdf' };
  originalUser: any;
  loginDetails: any = {};
  isApiError: boolean;
  isShowLogOutConfirm: boolean;
  shopList: any = [{ ShopName: 'All', ID: 0 }];
  CartCount: number = 0;
  selectedUser: any = {};
  isRouteUser: boolean;
  iSelectedRoute: boolean;
  loggedInUserID: number = 0;
  isShowReportList: boolean = false;

  isSuperAdmin!: boolean;
  isSelectedSuper!: boolean;

  isReseller!: boolean;
  shopeDomainName: any;
  appName: string;
  registrationData: any;
  isCollapsed: boolean = true;

  showBackButton: boolean = false;
  menuItemsList: any = menuItems;
  adminDetails: any;
  isOldSwithUIHidden: boolean = false;
  suscriptionFeatures: any = {};
  private subscriptionsToUnsubscribe = new Subscription();

  constructor(
    private router: Router,
    private backOfficeService: BackOfficeService,
    public apiService: ApiService,
    private vs: VariantService,
    // private fcmService: FcmService,
    public configService: ConfigService,
    // public modalService:ModalService
    private route: ActivatedRoute,
    private location: Location,
    private utilityService: UtilityService,
    public privilegeService: PrivilegesService,
    private featureFlagService: FeatureFlagService,
    private subscriptionsService: SubscriptionsService,
  ) { }

  ngOnInit(): void {
    this.privilegeService.getUserPrivileges();
    this.adminDetails = this.apiService.getRealUserData();

    // Subscribe to subscription features updates from service
    const subsSub = this.subscriptionsService.subscriptionFeatures$.subscribe((features: any) => {
      if (features) {
        this.suscriptionFeatures = features;
        this.setSubscriptionFeatures();
      }
    });
    this.subscriptionsToUnsubscribe.add(subsSub);

    // PRIVILEGES
    const dashboardMenu = this.menuItemsList.find(
      item => item.id === 'dashboard'
    );
    if (dashboardMenu && !this.privilegeService.getServicenearPrivilege('dashboard', true)) {
      dashboardMenu.hidden = true;
    }

    const shopCustomersMenu = this.menuItemsList.find(
      item => item.id === 'shopscustomers'
    );

    const addShopItem = shopCustomersMenu?.children.find(
      item => item.id === 'addshop'
    );
    if (addShopItem && !this.privilegeService.getServicenearPrivilege('addShop', true)) {
      addShopItem.disabled = true;
    }

    const shopListItem = shopCustomersMenu?.children.find(
      item => item.id === 'shoplist'
    );
    if (shopListItem && !this.privilegeService.getServicenearPrivilege('listShop', true)) {
      shopListItem.disabled = true;
    }

    const customerListItem = shopCustomersMenu?.children.find(
      item => item.id === 'customerlist'
    );
    if (customerListItem && !this.privilegeService.getServicenearPrivilege('listCustomer', true)) {
      customerListItem.disabled = true;
    }

    const addCustomerItem = shopCustomersMenu?.children.find(
      item => item.id === 'addcustomer'
    );
    if (addCustomerItem && !this.privilegeService.getServicenearPrivilege('addCustomer', true)) {
      addCustomerItem.disabled = true;
    }
    
    this.isOldSwithUIHidden = this.featureFlagService.getFeatureStatus('hide_servicenear_oldSwitchUI', true);
  }

  ngOnDestroy(): void {
    this.subscriptionsToUnsubscribe.unsubscribe();
  }

  public closeSideNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("myCloseContainer").style.width = "0";
    document.body.style.overflow = ''; // restore default
  }

  public gotoPage(path) {
    if (path === '/servicenear/logout') {
      this.configService.logoutUser(false, true);
    } else if (path === '/?activateoldui=true') {
      this.routeToServicenear();
    } else {
      const currentParams = this.route.snapshot.queryParams;
      this.router.navigate([path], { queryParams: currentParams });
    }
    this.closeSideNav();
  }

  public navigateToJobDetails(itemId: any) {
    const { thirdpartyuserkey, thirdpartyappurl } = this.route.snapshot.queryParams;
    this.router.navigate(['/servicenear/serviceDetails'], { queryParams: { workID: itemId, thirdpartyuserkey, thirdpartyappurl } });
  }

  get profileName(){
    let adminDetails = JSON.parse(localStorage.getItem('admin_Details') || '{}');
    return adminDetails?.Name;
  }

  showReports(event: boolean) {
    if (this.isShowReportList === false) {
      this.isShowReportList = true;
    } else {
      this.isShowReportList = false;
    }
  }

  public routeToServicenear() {
    const thirdPartyAppUrl = this.utilityService.getParamValueFromAnyUrl('thirdpartyappurl');
    const thirdPartyLogoutURl = thirdPartyAppUrl + '/?activateoldui=true';
    window.location.href = thirdPartyLogoutURl;
  }

  public logOutClicked() {
    this.configService.isShowLogOutConfirm = true;
    this.closeSideNav();
    // this.modalService.open(logoutTemplate, false, this.isShowLogOutConfirm);
  }

  ActivateSearch() {
    this.isSearchActive = !this.isSearchActive;
    // this.onSearchClicked.emit(this.isSearchActive);
  }

  public filterClick() {
    // this.isFilterActive = !this.isFilterActive;
    // this.onFilterClick.emit(this.isFilterActive)
    // this.onFilterClick.emit(true);
  }

  public clearUserSelection() {
    this.backOfficeService.clearCustomerSelection();
    this.setUpUser();
    this.gotoPage('/user/userlist');
  }

  private setUpUser() {
    this.selectedUser = this.apiService.getSelecterUserData();
    this.originalUser = this.apiService.getRealUserData();

    this.isRouteUser = this.originalUser?.UserType === 'admin' ? true : false; //removed soon
    this.iSelectedRoute =
      this.selectedUser?.UserType === 'admin' ? true : false; //removed soon

    this.isSuperAdmin =
      this.originalUser.UserType == 'superadmin' ? true : false;
    this.isSelectedSuper =
      this.selectedUser.UserType == 'superadmin' ? true : false;
  }

  public gotoAddProduct() {
    if (this.isReseller) {
      this.router.navigate(['/Reseller/AddProduct']);
    } else {
      if (location.hash.split('/')[2] == "product-edit") {
        this.vs.initVariantService(0);
      }
      this.router.navigate(['/products/product-edit', 0]);
    }
    this.closeSideNav();
  }

  ShareMyStore() {
    const shopeDomainName = this.configService.getLoginDetails()?.SubDomain;
    const appName = environment.appName.toLowerCase();
    const shareableLink = `https://${shopeDomainName}`;

    if (shopeDomainName && appName) {
      if (navigator.share) {
        navigator.share({
          title: 'Share My Store',
          text: 'Check out my store',
          url: shareableLink,
        }).catch((error) => {
          console.error('Sharing failed:', error);
        });
      }
    } else {

    }
    this.closeSideNav();
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  checkBackButton() {
    const currentUrl = this.router.url;
    this.showBackButton = !currentUrl.startsWith('/servicenear/dashboard');
  }

  public gotoContactUsPage(){
    const currentParams = this.route.snapshot.queryParams;
    this.router.navigate(['/servicenear/contactUs'], { queryParams: currentParams });
    this.closeSideNav();
  }

  public goToProfilePage(){
    const currentParams = this.route.snapshot.queryParams;
    this.router.navigate(['/servicenear/profile'], { queryParams: currentParams });
    this.closeSideNav();
  }

  private disableAllChildren(items: any) {
    for (const item of items) {
      item.disabled = true;

      if (item.children?.length) {
        this.disableAllChildren(item.children);
      }
    }
  }

  private enableAllChildren(items: any) {
    for (const item of items) {
      item.disabled = false;

      if (item.children?.length) {
        this.enableAllChildren(item.children);
      }
    }
  }

  private setSubscriptionFeatures(){
    const dashboardMenu = this.menuItemsList.find(
      item => item.id === 'dashboard'
    );
    
    if(dashboardMenu && this.suscriptionFeatures){
      if(this.suscriptionFeatures?.dashboard?.show){
        dashboardMenu.hidden = false;
      }else{
        dashboardMenu.hidden = true;
      }
      if(this.suscriptionFeatures?.dashboard?.disable){
        dashboardMenu.disabled = true;
      }else{
        dashboardMenu.disabled = false;
      }

      if(this.suscriptionFeatures?.dashboard === undefined){
        dashboardMenu.hidden = false;
        dashboardMenu.disabled = true;
      }
    }

    const salesMenu = this.menuItemsList.find(
      item => item.id === 'sales'
    );
    const posItem = salesMenu?.children.find(
      item => item.id === 'pos'
    );
    if(posItem && this.suscriptionFeatures){
      if(this.suscriptionFeatures?.pos?.show){
        posItem.hidden = false;
      }else{
        posItem.hidden = true;
      }
      if(this.suscriptionFeatures?.pos?.disable){
        posItem.disabled = true;
      }else{
        posItem.disabled = false;
      }

      if(this.suscriptionFeatures?.pos === undefined){
        posItem.hidden = false;
        posItem.disabled = true;
      }
    }

    const secondhandMenu = this.menuItemsList.find(
      item => item.id === 'secondhand'
    );
    if(secondhandMenu && this.suscriptionFeatures){
      if(this.suscriptionFeatures?.secondhand?.show){
        secondhandMenu.hidden = false;
      }else{
        secondhandMenu.hidden = true;
      }
      if(this.suscriptionFeatures?.secondhand?.disable){
        if (secondhandMenu?.children) {
          this.disableAllChildren(secondhandMenu.children);
        }
      }else{
        secondhandMenu.disabled = false;
        if (secondhandMenu?.children) {
          this.enableAllChildren(secondhandMenu?.children);
        }
      }

      if(this.suscriptionFeatures?.secondhand === undefined){
        secondhandMenu.hidden = false;
        if (secondhandMenu?.children) {
          this.disableAllChildren(secondhandMenu.children);
        }
      }
    }

    //customer
    const customerMenu = this.menuItemsList.find(
      item => item.id === 'shopscustomers'
    );
    const customerAddMenu = customerMenu?.children?.find(c => c.id === 'addcustomer');
    const shopAddMenu = customerMenu?.children?.find(c => c.id === 'addshop');

    if(customerAddMenu && this.suscriptionFeatures){
      if(this.suscriptionFeatures?.customer?.show){
        customerAddMenu.hidden = false;
      }else{
        customerAddMenu.hidden = true;
      }
      if(this.suscriptionFeatures?.customer?.disable){
        customerAddMenu.disabled = true;
      }else{
        customerAddMenu.disabled = false;
      }

      if(this.suscriptionFeatures?.customer === undefined){
        customerAddMenu.hidden = false;
        customerAddMenu.disabled = true;
      }
    }

    if(shopAddMenu && this.suscriptionFeatures){
      if(this.suscriptionFeatures?.customer?.show){
        shopAddMenu.hidden = false;
      }else{
        shopAddMenu.hidden = true;
      }
      if(this.suscriptionFeatures?.customer?.disable){
        shopAddMenu.disabled = true;
      }else{
        shopAddMenu.disabled = false;
      }

      if(this.suscriptionFeatures?.customer === undefined){
        shopAddMenu.hidden = false;
        shopAddMenu.disabled = true;
      }
    }
  
    //Add reports suscription features in future
  }
}
